import { IServicePage } from "@/cms-models/service";
import useTextFormatter from "@/hooks/useTextFormatter";
import { imageUrl } from "@/utils";
import Image from "next/image";
import React from "react";

type Props = {
  data: IServicePage;
};

export const Vet2PetSection: React.FC<Props> = ({ data }) => {
  const { convertStringToParagraph } = useTextFormatter();
  return (
    <section className="container mx-auto pt-5 pb-10 sm:py-10 flex flex-col gap-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
        <div className="flex flex-col">
          <h1 className="heading mb-5 sm:mb-8 flex items-center gap-5">
            <div dangerouslySetInnerHTML={{ __html: data.section1_title }} />
          </h1>
          <div className="flex-1 flex">
            <div className="flex-1 flex flex-col">
              <div className="body text-secondary min-[517px]-w-[517px] w-full mb-3 sm:mb-6">
                {convertStringToParagraph(data.section1_description)}
              </div>

              <div className="flex-1" />

              {/* <div className="hidden lg:grid w-full max-w-[250px] rounded-3xl shadow-paper relative grid-cols-1 gap-7 "> */}
              {/* <div className="pt-4 pb-7 pl-8">
                  <MdStarRate className="text-warning ml-24 text-4xl -mb-5" />
                  <div className="head-value">4,5</div>
                  <div className="text-secondary text-sm">
                    {data.section1_rating_text}
                  </div>
                </div> */}
              {/*<Image className="absolute bottom-0 -right-4" src={imageUrl(data.section1_rating_image)} width={151} height={187} alt="customer-dog" />*/}
              {/* </div> */}
            </div>
          </div>
        </div>

        <div className="flex-shrink-0 flex flex-col-reverse sm:flex-row  items-start justify-center sm:justify-end relative">
          <Image
            className="hidden sm:block object-contain mx-auto lg:mx-0"
            src={imageUrl(data.section1_logo)}
            width={411}
            // objectFit="contain"
            height={600}
            alt="dog"
          />
          <Image
            className="block sm:hidden w-full"
            src={imageUrl(data.section1_logo)}
            width={327}
            height={240}
            alt="dog"
          />
        </div>
      </div>
      <div className="border shadow-paper rounded-2xl p-6 w-full bg-white">
        <div className="text-xl mb-4 sm:mb-12">
          {data.section1_top_review_text}
        </div>
        <div className="flex items-center">
          <div>
            <p className="font-semibold">{data.section1_reviewer_name}</p>
            <p className="text-sm text-secondary">
              {data.section1_reviewer_office}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
